<template>
  <el-collapse v-model="activeNames">
    <!-- 企业 -->
    <el-collapse-item
      v-if="
        common.categoryUid !== 'ed67aad9552b4f1b8520785b9cb4bfd1' &&
        common.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'
      "
      title="基本信息"
      name="1"
    >
      <info-item
        :title="['客户名称', '客户编号']"
        :data="[common.name, common.customerNo]"
      ></info-item>
      <info-item
        :title="['客户类型', '统一社会信用代码']"
        :data="[common.categoryName, detail.creditCode]"
      ></info-item>
      <info-item
        :title="['注册资金(万元)', '规模(人)']"
        :data="[common.capital, common.scale]"
      ></info-item>
      <info-item
        :title="['地区', '详细地址']"
        :data="[
          `${common.province}-${common.city}-${common.district}`,
          detail.streetAddress,
        ]"
      ></info-item>
      <el-row class="panel-item">
        <el-col :span="11" v-if="auth.view && auth.view.toggleStatus">
          <label>线索</label>
          <span
            class="link link-after"
            v-for="item in common.clues"
            :key="item.id"
            @click="toDetail(item.id)"
          >
            {{ item.name || "--" }}
          </span>
        </el-col>
        <el-col :span="11" v-else>
          <label>线索</label>
          <span class="link-after" v-for="item in common.clues" :key="item.id">
            {{ item.name || "--" }}
          </span>
        </el-col>
        <el-col class="el-col-offset-1" :span="11">
          <label>客户等级</label>
          <span>{{ detail.commonCustomer.customerLevelName || "--" }}</span>
        </el-col>
      </el-row>
    </el-collapse-item>
    <!-- 医院 -->
    <el-collapse-item
      v-if="common.categoryUid === 'ed67aad9552b4f1b8520785b9cb4bfd1'"
      title="基本信息"
      name="1"
    >
      <info-item :title="['客户名称']" :data="[common.name]"></info-item>
      <info-item
        :title="['客户编号', '客户类型']"
        :data="[common.customerNo, common.categoryName]"
      ></info-item>
      <info-item
        :title="['跟进状态', '医院等级']"
        :data="[detail.followUpStateName, detail.hospitalLevelName]"
      ></info-item>
      <info-item :title="['合作科室']" :data="[oprationDepartment]"></info-item>
      <info-item
        :title="['病床数', '当地医院排名']"
        :data="[detail.sickbedNumber, detail.hospitalRhanking]"
      ></info-item>
      <info-item
        :title="['职工人数', '负债率']"
        :data="[
          detail.employeeNumber,
          `${detail.liabilities ? detail.liabilities + '%' : ''}`,
        ]"
      ></info-item>
      <info-item
        :title="['覆盖人口(万)', '年收入(万元)']"
        :data="[detail.coverPopulation, detail.annualIncome]"
      ></info-item>
      <info-item
        :title="['年门诊人次(万)', '年住院人次(万)']"
        :data="[detail.outpatientVisits, detail.hospitalizationVisits]"
      ></info-item>
      <info-item
        v-if="detail.medicalEquipment !== 1"
        :title="['医疗设备']"
        :data="['无']"
      ></info-item>
      <info-item
        v-if="detail.medicalEquipment === 1"
        :title="['医疗设备', '设备总金额(万元)']"
        :data="['有', detail.deviceAmount]"
      ></info-item>
      <info-item
        v-if="detail.medicalEquipment === 1"
        :title="['设备名称']"
        :data="[detail.deviceName]"
      ></info-item>
      <info-item
        v-if="detail.consumables !== 1"
        :title="['耗材']"
        :data="['无']"
      ></info-item>
      <info-item
        v-if="detail.consumables === 1"
        :title="['耗材', '耗材流水(万元/年)']"
        :data="['有', detail.consumablesRunningWater]"
      ></info-item>
      <info-item :title="['备注']" :data="[detail.customerRemarks]"></info-item>
      <info-item
        :title="['地区', '详细地址']"
        :data="[
          `${common.province}-${common.city}-${common.district}`,
          detail.streetAddress,
        ]"
      ></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[common.salesmanName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <!-- 医生 -->
    <el-collapse-item
      v-if="common.categoryUid === 'b8b2e093efd548a18259807bcb7fda2f'"
      title="基本信息"
      name="1"
    >
      <info-item :title="['客户名称']" :data="[detail.doctorName]"></info-item>
      <info-item
        :title="['客户类型', '医院']"
        :data="[common.categoryName, detail.hospitalName]"
      ></info-item>
      <info-item
        :title="['科室', '职称']"
        :data="[detail.hospDeptName, detail.doctorAdminTitleName]"
      ></info-item>
      <info-item :title="['擅长']" :data="[detail.feature]"></info-item>
      <info-item :title="['标签']" :data="[detail.doctorLabel]"></info-item>
      <info-item :title="['运营标签']" :data="[detail.commonCustomer.lableNames]"></info-item>
      <info-item
        :title="['昨日访问', '总访问']"
        :data="[detail.visitYesterday, detail.visitSum]"
      ></info-item>
      <info-item
        :title="['本月患者', '总患者']"
        :data="[detail.patientThisMonth, detail.patientSum]"
      ></info-item>
      <info-item
        :title="['本月评论', '总评论']"
        :data="[detail.commentThisMonth, detail.commentSum]"
      ></info-item>
      <info-item
        :title="['本月点赞', '总点赞']"
        :data="[detail.goodThisMonth, detail.goodSum]"
      ></info-item>
      <info-item
        :title="['本月差评', '总差评']"
        :data="[detail.bedThisSum, detail.bedSum]"
      ></info-item>
      <info-item
        :title="['本月订单量', '总订单量']"
        :data="[detail.orderThisMonth, detail.orderSum]"
      ></info-item>
      <info-item
        :title="['本月营收', '总营收']"
        :data="[detail.incomeThisMonth, detail.incomeSum]"
      ></info-item>
      <info-item
        :title="['周均接诊率', '平均接诊率']"
        :data="[detail.clinicalProbabilityWeekly, detail.clinicalProbabilityAverage]"
      ></info-item>
      <info-item
        :title="['周均回复时间', '平均回复时间']"
        :data="[detail.replyTimeWeekly, detail.replyTimeAverage]"
      ></info-item>
      <info-item
        :title="['本月登录天数', '总登录天数']"
        :data="[detail.onlineThisMonth, detail.onlineSum]"
      ></info-item>
      <info-item
        :title="['最近登录时间', '注册时间']"
        :data="[detail.lastVisitTime, detail.regDate]"
      ></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[common.salesmanName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <!-- 企业/医院 -->
    <el-collapse-item
      v-if="common.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'"
      title="系统信息"
      name="2"
    >
      <info-item
        :title="['创建人', '创建时间']"
        :data="[common.principalName, common.gmtCreatedStr]"
      ></info-item>
      <info-item
        :title="['最后修改人', '最后修改时间']"
        :data="[common.operatorName, common.gmtModifiedStr]"
      ></info-item>
      <info-item
        v-if="
          common.categoryUid !== 'ed67aad9552b4f1b8520785b9cb4bfd1' &&
          common.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'
        "
        :title="['审核日期', '机构ID']"
        :data="[common.approvalTimeStr, common.orgCode]"
      ></info-item>
      <info-item
        v-else
        :title="['审核日期']"
        :data="[common.approvalTimeStr]"
      ></info-item>
      <info-item
        :title="['机构审核状态', '划入公海计时']"
        :data="[filterStatus(common.orgState), common.countDown]"
      ></info-item>
      <info-item :title="['审核人']" :data="[common.approvalPerson]"></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    detail: Object,
    common: Object,
  },
  components: {
    InfoItem,
  },
  // filters: {
  //   filterStatus(value) {
  //     // 机构Code审核状态： 0-草稿，1-待审核，2-审核通过，3-驳回，4-拒绝
  //     const list = [
  //       { key: 0, value: '草稿' },
  //       { key: 1, value: '待审核' },
  //       { key: 2, value: '审核通过' },
  //       { key: 3, value: '驳回' },
  //       { key: 4, value: '拒绝' },
  //     ];

  //     return list.find(v => v.key === value).value;
  //   },
  // },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
    }),
  },
  watch: {
    "detail.customerDetail": {
      handler() {
        this.oprationDepartment = "";
        if (this.detail.customerDetail) {
          this.detail.customerDetail.forEach((item) => {
            this.oprationDepartment =
              this.oprationDepartment === ""
                ? item.dictName
                : `${this.oprationDepartment};${item.dictName}`;
          });
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      activeNames: ["1", "2"],
      oprationDepartment: "",
    };
  },
  methods: {
    toDetail(id) {
      this.$emit("toDetail", id);
    },
    filterStatus(value) {
      if (!value) return "--";
      // 机构Code审核状态： 0-草稿，1-待审核，2-审核通过，3-驳回，4-拒绝
      const list = [
        { key: 0, value: "草稿" },
        { key: 1, value: "待审核" },
        { key: 2, value: "审核通过" },
        { key: 3, value: "驳回" },
        { key: 4, value: "拒绝" },
      ];

      return list.find((v) => v.key === value).value;
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  .el-col {
    display: flex;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
  .link-after {
    &:last-child::after {
      content: "";
    }
  }
  .link-after::after {
    content: "、";
  }
}
</style>
